import React, { useState } from 'react';
import { Modal, Select, MenuItem, Checkbox, ListItemText, Button, FormControl, InputLabel, FormControlLabel } from '@mui/material';
import { generateDropDownList } from 'utility/helper';

interface VinSelectionModalProps {
    isOpen: boolean;
    onClose: () => void;
    signalPairs: any[];
    vinListData: string[];
    onVinSelect: (selectedVins: string[][]) => void;
    handleSelectedVinGroup: any;
    selectedVinList: any;
    selectedVinGroup: any;
}

const VinSelectionModal: React.FC<VinSelectionModalProps> = ({ isOpen, onClose, signalPairs, vinListData, onVinSelect, handleSelectedVinGroup, selectedVinList, selectedVinGroup }) => {
    //const defaultDropDownData = selectedVinGroup?.length > 0 ? selectedVinGroup[0] : { dropdown1: [], dropdown2: [] };
    const [selectedVins, setSelectedVins] = useState<Array<{ dropdown1: string[]; dropdown2: string[] }>>(
        generateDropDownList(signalPairs, selectedVinGroup)
    );
    const [setSameVinGroup, setSetSameVinGroup] = useState(false);

    const handleVinChange = (index: number, dropdown: number, selected: string[]) => {
        setSelectedVins((prev) => {
            const newSelectedVins = [...prev];
            newSelectedVins[index] = {
                ...newSelectedVins[index],
                [dropdown === 1 ? 'dropdown1' : 'dropdown2']: selected,
            };

            if (setSameVinGroup) {
                if (index === 0) {
                    return signalPairs.map(() => ({
                        dropdown1: newSelectedVins[0].dropdown1,
                        dropdown2: newSelectedVins[0].dropdown2, 
                    }));
                } else {
                    return newSelectedVins.map((vins, i) => ({
                        dropdown1: i === 0 ? newSelectedVins[0].dropdown1 : vins.dropdown1,
                        dropdown2: i === 0 ? newSelectedVins[0].dropdown2 : vins.dropdown2,
                    }));
                }
            }
            // handleSelectedVinGroup(newSelectedVins);
            return newSelectedVins;
        });
    };
    
    const title = signalPairs.length === 1 ? 'SCATTER PLOT VIN LIST' : 'MULTI SCATTER PLOT VIN LIST';

    const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setSetSameVinGroup(event.target.checked);
        if (event.target.checked) {
            const firstPairSelectedVins = selectedVins[0];
            const newSelectedVins = signalPairs.map(() => ({
                dropdown1: firstPairSelectedVins.dropdown1,
                dropdown2: firstPairSelectedVins.dropdown2,
            }));
            setSelectedVins(newSelectedVins);
        } else {
            setSelectedVins(signalPairs.map(() => ({ dropdown1: [], dropdown2: [] })));
        }
    };

    return (
        <Modal open={isOpen} onClose={onClose}>
            <div style={{ backgroundColor: 'white', padding: '20px 30px', borderRadius: '8px', outline: 'none', minWidth: '60%', position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }}>
                <div style={{display: 'flex', justifyContent:'space-between', alignItems:'center', flexWrap:'wrap', marginBottom:'24px'}}>
                    <h2 style={{fontSize: '18px', display: 'inline-block', margin:'unset'}}>{title}</h2>
                    {signalPairs.length > 1 && (
                        <div style={{display: 'inline-block'}}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={setSameVinGroup}
                                        onChange={handleCheckboxChange}
                                    />
                                }
                                label="Set same VIN group for all signal pairs"
                            />
                        </div>
                    )}
                </div>
                <div style={{maxHeight: '290px', overflowY:'scroll', marginBottom: '12px', padding: '8px 12px'}}>
                    {signalPairs.map((pair, index) => (
                        <div key={index} style={{display: 'flex', flexDirection:'row', gap: '19px', alignItems: 'center', marginBottom: '30px'}}>
                            <h3 style={{fontSize: '14px', display: 'inline-block', padding: '12px', border: '1px solid #dedede', borderRadius: '8px', height: 'fit-content', textAlign: 'center', width: '50%' }}>{pair.signal1}, {pair.signal2}</h3>
                            <div style={{display: 'flex', flexDirection:'row', position: 'relative' }}>
                                <div style={{display: 'flex', flexDirection:'row', alignItems:'center', justifyContent:'center'}}>
                                    <div style={{ borderLeft: '1px solid #000000', height: '40px', marginLeft: '0px', marginRight: '19px', width: '1px', transform: 'rotate(90deg)' }}></div>
                                    <div style={{ borderLeft: '1px solid #000000', borderTop: '1px solid #000000', borderBottom: '1px solid #000000', width: '30px', height: '65px', marginLeft: '0px', marginRight: '0px' }}></div>
                                </div>
                                <div style={{display: 'flex', flexDirection:'column', gap: '8px', position: 'relative' }}>
                                    <FormControl style={{ minWidth: 388 }}>
                                        <InputLabel>Select GroupA VINs</InputLabel>
                                        <Select
                                            multiple
                                            value={selectedVins[index]?.dropdown1 || []}
                                            onChange={(event) => handleVinChange(index, 1, Array.isArray(event.target.value) ? event.target.value : [event.target.value])}
                                            renderValue={(selected) => {
                                                if (selected.length === 0) return '';
                                                return `${selected[0]} ${selected?.length > 1 ? `(+${selected?.length - 1})` : ''}`; 
                                            }}
                                            disabled={setSameVinGroup && index > 0}
                                            label="Select GroupA VINs"
                                        >
                                            {vinListData.map((vin) => (
                                                <MenuItem key={vin} value={vin} disabled={selectedVins[index]?.dropdown2.includes(vin)}>
                                                    <Checkbox checked={selectedVins[index]?.dropdown1.includes(vin)} />
                                                    <ListItemText primary={vin} />
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                    <FormControl style={{ minWidth: 388 }}>
                                        <InputLabel>Select GroupB VINs</InputLabel>
                                        <Select
                                            multiple
                                            value={setSameVinGroup && index > 0 ? selectedVins[0]?.dropdown2 : selectedVins[index]?.dropdown2 || []}
                                            onChange={(event) => handleVinChange(index, 2, Array.isArray(event.target.value) ? event.target.value : [event.target.value])}
                                            renderValue={(selected) => {
                                                if (selected.length === 0) return '';
                                                return `${selected[0]} ${selected?.length > 1 ? `(+${selected?.length - 1})` : ''}`; 
                                            }}
                                            disabled={setSameVinGroup && index > 0}
                                            label="Select GroupB VINs"
                                        >
                                            {vinListData.map((vin) => (
                                                <MenuItem key={vin} value={vin} disabled={selectedVins[index]?.dropdown1.includes(vin)}>
                                                    <Checkbox checked={selectedVins[index]?.dropdown2.includes(vin)} />
                                                    <ListItemText primary={vin} />
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
                <Button
                    style={{
                        textTransform: 'uppercase',
                        padding: '12px',
                        color: '#ffffff',
                        backgroundColor: selectedVins.some(vin => vin.dropdown1.length === 0 && vin.dropdown2.length === 0) ? '#cccccc' : '#eb0a1e',
                        display: 'block',
                        margin: '0 auto',
                    }}
                    onClick={() => {
                        const newSelectedVins = selectedVins.map(({ dropdown1, dropdown2 }) => ({
                            dropdown1: [...dropdown1],
                            dropdown2: [...dropdown2],
                        }));
                        const newSelectedVinsRestructure = selectedVins.map(({ dropdown1, dropdown2 }) => ([
                            ...dropdown1,
                            ...dropdown2,
                        ]));
                        handleSelectedVinGroup(newSelectedVins); 
                        onVinSelect(newSelectedVinsRestructure);
                    }}
                    disabled={selectedVins.some(vin => vin.dropdown1.length === 0 && vin.dropdown2.length === 0)}
                >
                    Apply VIN Selection
                </Button>
            </div>
        </Modal>
    );
};

export default VinSelectionModal;